import { ProductOption } from '../service/ProductConfiguration.types';

export const createProductOptions = (options: string[]): ProductOption[] => options.map((option) => ({
  label: option,
  title: option,
  value: option,
}));
